module.exports = __webpack_public_path__ + "img/3-down.3238533d.png";